import { Occupation } from "./v1";

export const occupationOptions = Object.entries(Occupation)
	.filter(([value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
